<template>
  <div
    :class="[
      'discovery-stats-chart-source',
      { 'discovery-stats-chart-source--active': isActive },
    ]"
  >
    <p>{{ title }}</p>
  </div>
</template>

<script>
export default {
  name: 'DiscoveryStatsChartSource',

  props: {
    title: {
      type: String,
      required: true,
    },
    isActive: Boolean,
  },
};
</script>

<style lang="scss">
.discovery-stats-chart-source {
  border-radius: 8px;
  text-align: center;
  border: 1px solid #eaeef4;
  font-size: rem-calc(14px);
  font-weight: 400;
  color: #c0c4cc;
  padding: $global-padding * 0.5;
  cursor: pointer;
  background: #fafafa;
  margin-right: $global-margin;

  @include rtl() {
    margin-right: 0;
    margin-left: $global-margin;
  }

  p {
    margin-bottom: 0;
  }

  &--active {
    border-color: #000;
    color: #000;
  }
}
</style>
